import { ResolverService } from './shared/resolver/resolver.service';
import { AuthGuardService } from './shared/auth-guard/auth-guard.service';
import { HeaderBodyFooterAdderComponent } from './theme/header-body-footer-adder/header-body-footer-adder.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BlockRouteResolverForSentryService } from './shared/blockRouteResolverForsentry/block-route-resolver-for-sentry.service';
import { HttpComponent } from './static-pages/http/http.component';
import { HttpErrorComponent } from './static-pages/http-error/http-error.component';
import { directLiginComponent } from './static-pages/direct-login/direct-login.component';

const routes: Routes = [
  // { path: '', redirectTo: '/', pathMatch: 'full' },

  {
    path: '',
    component: HeaderBodyFooterAdderComponent,
    children: [
      {
        path: '',
        // loadChildren: () => import('./dashboard-landing-page/dashboard-landing-page.module').then(m => m.DashboardLandingPageModule),
        loadChildren: () => import('./landing-page/landing-page.module').then(m => m.LandingPageModule),
        data: {
          title: 'Home',
          description: ''
        }
      },
      {
        path: 'login', resolve: { ResolverService }, loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
        data: {
          title: 'Login',
          description: 'Log in to the National Apprenticeship Promotion Scheme (NAPS) portal to manage apprenticeships, applications, contracts and stipend services.',
          keywords: 'NAPS login, apprenticeship login, establishment login, portal sign in'
        }
      },
      {
        path: 'direct-login', component: directLiginComponent,
        data: {
          title: 'Login',
          description: 'Log in to the National Apprenticeship Promotion Scheme (NAPS) portal to access your apprenticeship dashboard and services.',
          keywords: 'NAPS login, apprenticeship login, portal sign in'
        }
      },
      {
        path: 'candidate-login', resolve: { ResolverService }, loadChildren: () => import('./candidate-login/candidate-login.module').then(m => m.candidateLoginModule),
        data: {
          title: 'Candidate Login',
          description: 'Candidate login for the National Apprenticeship Promotion Scheme (NAPS) portal to view opportunities, apply for apprenticeships and track applications.',
          keywords: 'candidate login, apprentice login, NAPS, apprenticeship application'
        }
      },
      {
        path: 'http-error',component:HttpComponent,
        data: {
          title: 'HTTP-Error',
          description: 'An error occurred while accessing the National Apprenticeship Promotion Scheme (NAPS) portal.',
          keywords: 'error, NAPS, apprenticeship portal'
        }
      },
      {
        path: 'url-error',component:HttpErrorComponent,
        data: {
          title: 'URL-Error',
          description: 'The requested page could not be found on the National Apprenticeship Promotion Scheme (NAPS) portal.',
          keywords: 'error, page not found, NAPS, apprenticeship portal'
        }
      },
      // {
      //   path: 'candidate-registration',
      //   loadChildren: './candidate-registration/candidate-registration.module#CandidateRegistrationModule',
      //   data: {
      //     title: 'Candidate Registration',
      //     description: ''
      //   }

      // },
      {
        path: 'mela-registration',
        loadChildren: () => import('./apprenticeship-mela-registration/apprenticeship-mela-registration.module').then(m => m.ApprenticeshipMelaRegistrationModule),
        data: {
          title: 'Candidate/Establishment Registration',
          description: 'Register as a candidate or establishment for apprenticeship melas under the National Apprenticeship Promotion Scheme (NAPS).',
          keywords: 'apprenticeship mela registration, candidate registration, establishment registration, NAPS'
        }

      },
      // {
      //   path: 'college-registration',
      //   loadChildren: './college-registration/college-registration.module#CollegeRegistrationModule',
      //   data: {
      //     title: 'College Registration',
      //     description: ''
      //   }

      // },
      {
        path: 'tpa-registration',
        loadChildren: () => import('./tpa-registration/tpa-registration.module').then(m => m.TpaRegistrationModule),
        data: {
          title: 'TPA Registration',
          description: 'Register as a Third Party Aggregator (TPA) on the National Apprenticeship Promotion Scheme (NAPS) portal to facilitate apprenticeship engagements.',
          keywords: 'TPA registration, third party aggregator, NAPS, apprenticeship'
        }

      },
      {
        path: 'btp-registration',
        loadChildren: () => import('./btp-registration/btp-registration.module').then(m => m.BTPRegistrationModule),
        data: {
          title: 'BTP Registration',
          description: 'Register as a Basic Training Provider (BTP) on the National Apprenticeship Promotion Scheme (NAPS) portal to deliver apprenticeship basic training.',
          keywords: 'BTP registration, basic training provider, NAPS, apprenticeship training'
        }

      },
      {
        path: 'order-status',
        loadChildren: () => import('./payment-order/payment-order.module').then(m => m.PaymentOrderModule),
        data: {
          title: 'Payment Information',
          description: ''
        }

      },
      {
        path: 'order-status/cancel',
        loadChildren: () => import('./payment-order/payment-order.module').then(m => m.PaymentOrderModule),
        data: {
          title: 'Payment Information',
          description: ''
        }

      },
      {
        path: 'establishment-registration',
        loadChildren: () => import('./establishment-registration/establishment-registration.module').then(m => m.EstablishmentRegistrationModule),
        data: {
          title: 'Establishment Registration',
          description: 'Register your establishment on the National Apprenticeship Promotion Scheme (NAPS) portal to engage apprentices and access government incentives.',
          keywords: 'establishment registration, employer registration, NAPS, apprenticeship, hire apprentices'
        }
      },
      {
        path: 'pmnam-map',
        loadChildren: () => import('./apprenticeship-mela/apprenticeship-mela.module').then(m => m.ApprenticeshipMelaModule),
        data: {
          title: 'Apprenticeship Mela',
          description: 'Find PM National Apprenticeship Mela (PMNAM) locations and events across India under the National Apprenticeship Promotion Scheme (NAPS).',
          keywords: 'apprenticeship mela, PMNAM, PM national apprenticeship mela, NAPS, apprenticeship events'
        }
      },
     
      // {
      //   path: 'order-details',
      //   loadChildren: './nimi-payment-status/nimi-payment-status.module#NimiPaymentStatusModule',
      //   data: {
      //     title: 'Payment Status',
      //     description: ''
      //   }
      // },
      {
        path: 'nimi/order-status',
        loadChildren: () => import('./nimi-payment-status/nimi-payment-status.module').then(m => m.NimiPaymentStatusModule),
        data: {
          title: 'Payment Status',
          description: ''
        }
      },
      {
        path: 'apprenticeship',
        loadChildren: () => import('./apprentice-opportunities/apprentice-opportunities.module').then(m => m.ApprenticeOpportunitiesModule),
        data: {
          title: 'All Opportunities',
          description: 'Browse all live apprenticeship opportunities across India on the National Apprenticeship Promotion Scheme (NAPS) portal and apply to the ones that match your skills.',
          keywords: 'apprenticeship opportunities, apprentice jobs, apprenticeship vacancies, NAPS, apply apprenticeship, skill development'
        }
      },
      {
        path: 'courses',
        loadChildren: () => import('./all-published-courses/all-published-courses.module').then(m => m.AllPublishedCoursesModule),
        data: {
          title: 'All Published Courses',
          description: 'Explore all published apprenticeship courses and trades available under the National Apprenticeship Promotion Scheme (NAPS).',
          keywords: 'apprenticeship courses, trades, NAPS, skill courses, apprenticeship training programs'
        }
      },
      { path: 'dashboard', resolve: { ResolverService }, loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
      {
        path: 'candidate',
        canLoad: [AuthGuardService],
        data: {
          allowedRole: 'candidate'
        },
        resolve: { BlockRouteResolverForSentryService },
        loadChildren: () => import('./candidate/candidate.module').then(m => m.CandidateModule)
      },
      {
        path: 'activate/:userId/:token',
        loadChildren: () => import('./dashboard-landing-page/dashboard-landing-page.module').then(m => m.DashboardLandingPageModule),
        data: {
          title: 'Account Activation',
          description: ''
        }
      },
      {
        path: 'activate-email/:userIdEmail/:tokenEmail',
        loadChildren: () => import('./dashboard-landing-page/dashboard-landing-page.module').then(m => m.DashboardLandingPageModule),
        data: {
          title: 'Email Activation',
          description: ''
        }
      },
      {
        path: 'apprentice/services',
        loadChildren: () => import('./apprentice-services/apprentice-services.module').then(m => m.ApprenticeServicesModule),
        data: {
          title: 'Apprentice Services'
        }
      },
    ]
  },
  {
    path: '', component: HeaderBodyFooterAdderComponent,
    children: [
      {
        path: '**', resolve: { ResolverService }, loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
        data: {
          title: 'Login',
          description: ''
        }
      },
    ]
  },
  // {
  //   path: '**', component: PageNotFoundComponent,
  //   data: {
  //     title: 'Page Not Found',
  //     description: ''
  //   }
  // }


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
